<div class="ion-padding">
  <h1 class="ion-text-center">Environments</h1>
  <p class="main-heading">Your current environment is:</p>
  <p class="text-bold" style="padding-top:5px">{{currentEnvironment.url}}</p>
  <p>You may change environment by selecting another one below.</p>
  <form [formGroup]="envForm">
    <ion-list>
      <ion-radio-group
        formControlName="env"
        id="env"
        [class.error-state-input]="formHelper.isInvalid(envForm.get('env'))">
        <p text-wrap>
          Select Environment:
        </p>
        @for (env of environments; track env) {
          <ion-item class="ion-no-padding">
            <ion-radio value="{{env.name}}" mode="md" (click)="updateEnvironment(env)" justify="start" labelPlacement="end">{{env.name}}</ion-radio>
          </ion-item>
        }
      </ion-radio-group>
    </ion-list>
  </form>
  <div class="button-group">
    <ion-button size="medium" shape="round" expand="full" (click)="dismiss()">Close</ion-button>
  </div>
</div>
